import React from 'react';
import { useAuth } from '@/features/auth/AuthProvider';
import { AlertBellNotification } from './AlertBellNotification';
import { Breadcrumbs } from './Breadcrumbs';
import { DeactivatedDokumenttypMappingsNotification } from './DeactivatedDokumenttypMappingsNotification';

export const Header: React.FC = () => {
  const { user } = useAuth();

  return (
    <header className="bg-header-bg text-header-text border-b border-table-border">
      <div className="px-8 py-2">
        <div className="flex items-center h-12">
          <div className="flex items-center gap-3">
            <AlertBellNotification />
            <Breadcrumbs />
          </div>

          <div className="ml-auto flex items-center space-x-10">
            <DeactivatedDokumenttypMappingsNotification />
            <span className="text-sm font-medium">Hallo, {user?.name}</span>
          </div>
        </div>
      </div>
    </header>
  );
};
